/*************************************************/
/* FILTER                                        */
/*************************************************/
import mixitup from "mixitup";

export function filter() {
    function getValueForFiltering(value) {
        return value ? `.${value}` : "all";
    }

    function updateQuery(key, value) {
        if ('URLSearchParams' in window) {
            const searchParams = new URLSearchParams(window.location.search);

            if (value) {
                searchParams.set(key, value);
            } else {
                searchParams.delete(key);
            }

            const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.replaceState(null, '', newRelativePathQuery);
        }
    }

    function handleFilterChange(e, mixer, filterQueryKey) {
        const selectedFilterValue = getValueForFiltering(e.target.value);
        const departmentHeadlines = document.querySelectorAll(".employee-section__headline");
        const associatedHeadline = document.querySelector(`[data-department="${selectedFilterValue.replace('.', '')}"]`);

        departmentHeadlines.forEach(headline => {
            headline.style.display = selectedFilterValue === "all" ? "block" : "none";
        });

        if (associatedHeadline) {
            associatedHeadline.style.display = "block";
        }

        mixer.filter(selectedFilterValue);
        updateQuery(filterQueryKey, e.target.value);
    }

    const filterSelector = '.filter';
    const filterInputSelector = '.filter__dropdown';

    document.querySelectorAll(filterSelector).forEach(filter => {
        const filterInput = filter.querySelector(filterInputSelector);
        const filterTargetsContainerSelector = filter.dataset.filterTargetsContainerSelector;
        const filterQueryKey = filter.dataset.filterQueryKey;

        if (filterInput && filterTargetsContainerSelector && filterQueryKey) {
            const mixer = mixitup(filterTargetsContainerSelector);

            if (filterInput.value || filterInput.selectedIndex !== undefined) {
                const initialValue = filterInput.value || filterInput.options[filterInput.selectedIndex].value;
                mixer.filter(getValueForFiltering(initialValue));
            }

            filterInput.addEventListener('change', e => {
                handleFilterChange(e, mixer, filterQueryKey);
            });
        }
    });
}
